export const getRideDeletePassengersPath = (
  companyId: number,
  id: number,
): string => `/api/v1/core/c/${companyId}/rides/${id}/passengers`;

export const getRideBulkRejectPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/reject`;
export const getRideBulkStatusNewPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/status-new`;
export const getRideBulkStatusDonePath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/status-done`;
export const getRideBulkStatusDoneApprovedPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/status-done-approved`;
export const getRideBulkStatusReceivedPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/status-received`;
export const getRideBulkRenewPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/renew`;
export const getRideBulkRebuildRoutesPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/rebuild-route`;
export const getRideBulkCloneRidesPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/clone`;
export const getJourneyBulkCloneRidesPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/ride-journeys/bulk/clone`;
export const getRidesJourneyAssignBulkPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/ride-journeys/bulk/journey-assign`;
export const getRideBulkSendToSupplierPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/send-to-supplier`;
export const getRideBulkRecalculatePricePath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/recalculate-price`;
export const getRideBulkRecalculateSupplierPricePath = (
  companyId: number,
): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/recalculate-supplier-price`;
export const getRideBulkSendSMSPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/send-sms`;
export const getRideBulkFetchTrackingHistoryPath = (
  companyId: number,
): string => `/api/v1/core/c/${companyId}/rides/bulk/fetch-tracking-history`;
export const getRideBulkFitVehicleAndRecalculatePath = (
  companyId: number,
): string =>
  `/api/v1/core/c/${companyId}/rides/bulk/fit-vehicle-and-recalculate`;
